module.exports = __webpack_public_path__ + "static/media/pic_404.752e9e19.png";